const benchmark_score = {
    default: {
        total: {
            avg: 77.8,
            top: 89.2
        },
        category1: {
            '1. 인권 및 노동': {avg: 75.3, top: 91.4},
            '2. 윤리': {avg: 80.4, top: 96.2},
            '3. 환경': {avg: 83.0, top: 100.0},
            '4. 안전': {avg: 86.0, top: 100.0}
        },
        category3: {
            '1.1.2. 인권 및 노동 컴플라이언스 리스크': {avg: 92.0, top: 100.0},
            '1.2.1. 인권 및 노동 정책 내재화': {avg: 55.0, top: 100.0},
            '1.2.2. 근로 관리': {avg: 75.8, top: 100.0},
            '1.2.3. 차별금지': {avg: 77.5, top: 100.0},
            '1.3.1. 비인도적 행위 금지': {avg: 48.9, top: 100.0},
            '1.3.2. 아동노동': {avg: 68.1, top: 81.3},
            '1.3.3. 강제노동': {avg: 85.5, top: 100.0},
            '1.3.4. 지역사회 및 토착민': {avg: 8.3, top: 100.0},
            '1.4.1. 근로환경 개선 활동': {avg: 83.3, top: 100.0},
            '1.4.2. 결사의 자유': {avg: 48.3, top: 100.0},
            '1.4.3. 고충 처리': {avg: 82.9, top: 100.0},
            '1.5.1. 협력사 행동규범': {avg: 79.6, top: 79.6},
            '1.5.2. 공급망 리스크 관리': {avg: 83.3, top: 83.3},
            '1.5.3. 공급망 강제노동 관리': {avg: 40.0, top: 40.0},
            '1.6.1. 기숙사 내 인권 관리': {avg: 100.0, top: 100.0},
            '1.6.2. 식당 내 인권 관리': {avg: 83.3, top: 100.0},
            '2.1.1. 윤리 컴플라이언스 리스크': {avg: 84.4, top: 100.0},
            '2.2.1. 윤리 경영': {avg: 75.0, top: 100.0},
            '2.2.2. 윤리 모니터링': {avg: 82.2, top: 100.0},
            '2.3.1. 개인정보 보호': {avg: 86.7, top: 100.0},
            '2.3.2. 정보 보안': {avg: 59.7, top: 83.3},
            '2.4.1. 책임있는 원자재 구매': {avg: 0.0, top: 0.0},
            '3.1.2. 환경 컴플라이언스 리스크': {avg: 100.0, top: 100.0},
            '3.2.1. 환경 정책': {avg: 64.3, top: 100.0},
            '3.2.2. 환경경영 활동': {avg: 49.3, top: 100.0},
            '3.3.1. 온실가스 배출량 관리': {avg: 66.7, top: 100.0},
            '3.3.2. 온실가스 저감 목표': {avg: 0.0, top: 0.0},
            '3.3.3. 온실가스 감축 활동': {avg: 30.0, top: 40.0},
            '3.3.4. 에너지 소비 및 전환': {avg: 33.3, top: 50.0},
            '3.4.1. 수자원 데이터': {avg: 100.0, top: 100.0},
            '3.4.2. 수자원 관리 활동': {avg: 100.0, top: 100.0},
            '3.5.1. 폐기물 데이터': {avg: 100.0, top: 100.0},
            '3.5.2. 폐기물 관리 활동': {avg: 87.5, top: 87.5},
            '3.6.1. 대기오염물질 데이터': {avg: 100.0, top: 100.0},
            '3.6.2. 대기오염물질 관리 활동': {avg: 91.7, top: 91.7},
            '3.7.3. 오존층 파괴물질 관리': {avg: 0.0, top: 0.0},
            '4.1.2. 안전 컴플라이언스': {avg: 100.0, top: 100.0},
            '4.2.1. 안전 정책': {avg: 85.5, top: 100.0},
            '4.3.1. 사업장 안전 및 보건 관리': {avg: 65.4, top: 100.0},
            '4.3.2. 재해 방지 및 대응': {avg: 87.5, top: 87.5},
            '4.3.3. 재해 데이터': {avg: 80.0, top: 100.0},
            '4.4.1. 화학물질 안전': {avg: 100.0, top: 100.0}
        },
    },
    '514': {
        'total': {
            'avg': 66.6,
            'top': 91.0
        },
        'category1': {
            '1. 인권 및 노동': { 'avg': 69.5, 'top': 94.3 },
            '2. 윤리': { 'avg': 67.9, 'top': 97.8 },
            '3. 환경': { 'avg': 56.4, 'top': 88.9 },
            '4. 안전': { 'avg': 68.9, 'top': 98.9 }
        },
        'category3': {
            '1.1.2. 인권 및 노동 컴플라이언스 리스크': { 'avg': 89.2, 'top': 100 },
            '1.2.1. 인권 및 노동 정책 내재화': { 'avg': 65.1, 'top': 100 },
            '1.2.2. 근로 관리': { 'avg': 77.1, 'top': 100 },
            '1.2.3. 차별금지': { 'avg': 48.6, 'top': 100 },
            '1.3.1. 비인도적 행위 금지': { 'avg': 60.5, 'top': 100 },
            '1.3.2. 아동노동': { 'avg': 39.2, 'top': 100 },
            '1.3.3. 강제노동': { 'avg': 77.0, 'top': 100 },
            '1.3.4. 지역사회 및 토착민': { 'avg': 32.9, 'top': 100 },
            '1.4.1. 근로환경 개선 활동': { 'avg': 69.7, 'top': 100 },
            '1.4.2. 결사의 자유': { 'avg': 65.8, 'top': 100 },
            '1.4.3. 고충 처리': { 'avg': 35.4, 'top': 100 },
            '1.5.1. 협력사 행동규범': { 'avg': 98.1, 'top': 98.1 },
            '1.5.2. 공급망 리스크 관리': { 'avg': 100, 'top': 100 },
            '1.5.3. 공급망 강제노동 관리': { 'avg': 100, 'top': 100 },
            '1.6.1. 기숙사 내 인권 관리': { 'avg': 97.2, 'top': 100 },
            '1.6.2. 식당 내 인권 관리': { 'avg': 90.2, 'top': 100 },
            '2.1.1. 윤리 컴플라이언스 리스크': { 'avg': 90.1, 'top': 100 },
            '2.2.1. 윤리 경영': { 'avg': 70.3, 'top': 100 },
            '2.2.2. 윤리 모니터링': { 'avg': 33.8, 'top': 100 },
            '2.3.1. 개인정보 보호': { 'avg': 62.5, 'top': 100 },
            '2.3.2. 정보 보안': { 'avg': 50.9, 'top': 100 },
            '2.4.1. 책임있는 원자재 구매': { 'avg': 15.6, 'top': 62.5 },
            '3.1.2. 환경 컴플라이언스 리스크': { 'avg': 91.4, 'top': 100 },
            '3.2.1. 환경 정책': { 'avg': 85.9, 'top': 100 },
            '3.2.2. 환경경영 활동': { 'avg': 42.8, 'top': 100 },
            '3.3.1. 온실가스 배출량 관리': { 'avg': 48.8, 'top': 100 },
            '3.3.2. 온실가스 저감 목표': { 'avg': 25, 'top': 50 },
            '3.3.3. 온실가스 감축 활동': { 'avg': 32.1, 'top': 100 },
            '3.3.4. 에너지 소비 및 전환': { 'avg': 30.5, 'top': 100 },
            '3.4.1. 수자원 데이터': { 'avg': 59.4, 'top': 100 },
            '3.4.2. 수자원 관리 활동': { 'avg': 20.1, 'top': 80 },
            '3.5.1. 폐기물 데이터': { 'avg': 69.7, 'top': 100 },
            '3.5.2. 폐기물 관리 활동': { 'avg': 31.3, 'top': 100 },
            '3.5.3. 유해 폐기물의 수입 및 수출': { 'avg': 'N/A', 'top': 'N/A' },
            '3.6.1. 대기오염물질 데이터': { 'avg': 47.1, 'top': 100 },
            '3.6.2. 대기오염물질 관리 활동': { 'avg': 25.8, 'top': 100 },
            '3.7.1. 수은 및 수은화합물 관리': { 'avg': 'N/A', 'top': 'N/A' },
            '3.7.2. 잔류성유기오염물질 관리': { 'avg': 'N/A', 'top': 'N/A' },
            '3.7.3. 오존층 파괴물질 관리': { 'avg': 0, 'top': 0 },
            '3.8.1. 멸종위기 야생 동·식물종의 수입 및 수출': { 'avg': 'N/A', 'top': 'N/A' },
            '3.8.2. 자연유산 및 습지': { 'avg': 'N/A', 'top': 'N/A' },
            '3.8.3. 해양 오염 방지': { 'avg': 'N/A', 'top': 'N/A' },
            '4.1.2. 안전 컴플라이언스': { 'avg': 86.8, 'top': 100 },
            '4.2.1. 안전 정책': { 'avg': 85.6, 'top': 100 },
            '4.3.1. 사업장 안전 및 보건 관리': { 'avg': 58.5, 'top': 100 },
            '4.3.2. 재해 방지 및 대응': { 'avg': 86.1, 'top': 100 },
            '4.3.3. 재해 데이터': { 'avg': 67.2, 'top': 100 },
            '4.4.1. 화학물질 안전': { 'avg': 57.9, 'top': 100 }
        }
    },
    '515': {
        'total': {
            'avg': 77.8,
            'top': 83.7
        },
        'category1': {
            '1. 인권 및 노동': { 'avg': 76.6, 'top': 87.6 },
            '2. 윤리': { 'avg': 71.5, 'top': 82.9 },
            '3. 환경': { 'avg': 77.8, 'top': 88.9 },
            '4. 안전': { 'avg': 84.3, 'top': 98.9 }
        },
        'category3': {
            '1.1.2. 인권 및 노동 컴플라이언스 리스크': { 'avg': 74.3, 'top': 100 },
            '1.2.1. 인권 및 노동 정책 내재화': { 'avg': 82.1, 'top': 100 },
            '1.2.2. 근로 관리': { 'avg': 75.6, 'top': 93.8 },
            '1.2.3. 차별금지': { 'avg': 63.5, 'top': 100 },
            '1.3.1. 비인도적 행위 금지': { 'avg': 74.6, 'top': 100 },
            '1.3.2. 아동노동': { 'avg': 75, 'top': 100 },
            '1.3.3. 강제노동': { 'avg': 77.9, 'top': 100 },
            '1.3.4. 지역사회 및 토착민': { 'avg': 53.6, 'top': 100 },
            '1.4.1. 근로환경 개선 활동': { 'avg': 87.5, 'top': 100 },
            '1.4.2. 결사의 자유': { 'avg': 85.7, 'top': 100 },
            '1.4.3. 고충 처리': { 'avg': 78.7, 'top': 100 },
            '1.5.1. 협력사 행동규범': { 'avg': 73.1, 'top': 100 },
            '1.5.2. 공급망 리스크 관리': { 'avg': 65.3, 'top': 83.3 },
            '1.5.3. 공급망 강제노동 관리': { 'avg': 60, 'top': 100 },
            '1.6.1. 기숙사 내 인권 관리': { 'avg': 95, 'top': 100 },
            '1.6.2. 식당 내 인권 관리': { 'avg': 95.2, 'top': 100 },
            '2.1.1. 윤리 컴플라이언스 리스크': { 'avg': 93.7, 'top': 100 },
            '2.2.1. 윤리 경영': { 'avg': 70.4, 'top': 100 },
            '2.2.2. 윤리 모니터링': { 'avg': 66.7, 'top': 100 },
            '2.3.1. 개인정보 보호': { 'avg': 78.6, 'top': 100 },
            '2.3.2. 정보 보안': { 'avg': 53.6, 'top': 75 },
            '2.4.1. 책임있는 원자재 구매': { 'avg': 20, 'top': 100 },
            '3.1.2. 환경 컴플라이언스 리스크': { 'avg': 91.1, 'top': 100 },
            '3.2.1. 환경 정책': { 'avg': 88.9, 'top': 100 },
            '3.2.2. 환경경영 활동': { 'avg': 77.1, 'top': 100 },
            '3.3.1. 온실가스 배출량 관리': { 'avg': 92.9, 'top': 100 },
            '3.3.2. 온실가스 저감 목표': { 'avg': 28.6, 'top': 100 },
            '3.3.3. 온실가스 감축 활동': { 'avg': 68.6, 'top': 100 },
            '3.3.4. 에너지 소비 및 전환': { 'avg': 78.6, 'top': 100 },
            '3.4.1. 수자원 데이터': { 'avg': 88.9, 'top': 100 },
            '3.4.2. 수자원 관리 활동': { 'avg': 70, 'top': 100 },
            '3.5.1. 폐기물 데이터': { 'avg': 100, 'top': 100 },
            '3.5.2. 폐기물 관리 활동': { 'avg': 78.6, 'top': 100 },
            '3.5.3. 유해 폐기물의 수입 및 수출': { 'avg': 'N/A', 'top': 'N/A' },
            '3.6.1. 대기오염물질 데이터': { 'avg': 90.5, 'top': 100 },
            '3.6.2. 대기오염물질 관리 활동': { 'avg': 73.8, 'top': 100 },
            '3.7.1. 수은 및 수은화합물 관리': { 'avg': 75, 'top': 100 },
            '3.7.2. 잔류성유기오염물질 관리': { 'avg': 'N/A', 'top': 'N/A' },
            '3.7.3. 오존층 파괴물질 관리': { 'avg': 0, 'top': 0 },
            '3.8.1. 멸종위기 야생 동·식물종의 수입 및 수출': { 'avg': 'N/A', 'top': 'N/A' },
            '3.8.2. 자연유산 및 습지': { 'avg': 'N/A', 'top': 'N/A' },
            '3.8.3. 해양 오염 방지': { 'avg': 0, 'top': 0 },
            '4.1.2. 안전 컴플라이언스': { 'avg': 57.1, 'top': 100 },
            '4.2.1. 안전 정책': { 'avg': 95.2, 'top': 100 },
            '4.3.1. 사업장 안전 및 보건 관리': { 'avg': 80.9, 'top': 100 },
            '4.3.2. 재해 방지 및 대응': { 'avg': 82.7, 'top': 100 },
            '4.3.3. 재해 데이터': { 'avg': 91.4, 'top': 100 },
            '4.4.1. 화학물질 안전': { 'avg': 70.4, 'top': 100 }
        }
    },
    '516': {
        'total': {
            'avg': 77.8,
            'top': 83.7
        },
        'category1': {
            '1. 인권 및 노동': { 'avg': 76.6, 'top': 87.6 },
            '2. 윤리': { 'avg': 71.5, 'top': 82.9 },
            '3. 환경': { 'avg': 77.8, 'top': 88.9 },
            '4. 안전': { 'avg': 84.3, 'top': 98.9 }
        },
        'category3': {
            '1.1.2. 인권 및 노동 컴플라이언스 리스크': { 'avg': 74.3, 'top': 100 },
            '1.2.1. 인권 및 노동 정책 내재화': { 'avg': 82.1, 'top': 100 },
            '1.2.2. 근로 관리': { 'avg': 75.6, 'top': 93.8 },
            '1.2.3. 차별금지': { 'avg': 63.5, 'top': 100 },
            '1.3.1. 비인도적 행위 금지': { 'avg': 74.6, 'top': 100 },
            '1.3.2. 아동노동': { 'avg': 75, 'top': 100 },
            '1.3.3. 강제노동': { 'avg': 77.9, 'top': 100 },
            '1.3.4. 지역사회 및 토착민': { 'avg': 53.6, 'top': 100 },
            '1.4.1. 근로환경 개선 활동': { 'avg': 87.5, 'top': 100 },
            '1.4.2. 결사의 자유': { 'avg': 85.7, 'top': 100 },
            '1.4.3. 고충 처리': { 'avg': 78.7, 'top': 100 },
            '1.5.1. 협력사 행동규범': { 'avg': 73.1, 'top': 100 },
            '1.5.2. 공급망 리스크 관리': { 'avg': 65.3, 'top': 83.3 },
            '1.5.3. 공급망 강제노동 관리': { 'avg': 60, 'top': 100 },
            '1.6.1. 기숙사 내 인권 관리': { 'avg': 95, 'top': 100 },
            '1.6.2. 식당 내 인권 관리': { 'avg': 95.2, 'top': 100 },
            '2.1.1. 윤리 컴플라이언스 리스크': { 'avg': 93.7, 'top': 100 },
            '2.2.1. 윤리 경영': { 'avg': 70.4, 'top': 100 },
            '2.2.2. 윤리 모니터링': { 'avg': 66.7, 'top': 100 },
            '2.3.1. 개인정보 보호': { 'avg': 78.6, 'top': 100 },
            '2.3.2. 정보 보안': { 'avg': 53.6, 'top': 75 },
            '2.4.1. 책임있는 원자재 구매': { 'avg': 20, 'top': 100 },
            '3.1.2. 환경 컴플라이언스 리스크': { 'avg': 91.1, 'top': 100 },
            '3.2.1. 환경 정책': { 'avg': 88.9, 'top': 100 },
            '3.2.2. 환경경영 활동': { 'avg': 77.1, 'top': 100 },
            '3.3.1. 온실가스 배출량 관리': { 'avg': 92.9, 'top': 100 },
            '3.3.2. 온실가스 저감 목표': { 'avg': 28.6, 'top': 100 },
            '3.3.3. 온실가스 감축 활동': { 'avg': 68.6, 'top': 100 },
            '3.3.4. 에너지 소비 및 전환': { 'avg': 78.6, 'top': 100 },
            '3.4.1. 수자원 데이터': { 'avg': 88.9, 'top': 100 },
            '3.4.2. 수자원 관리 활동': { 'avg': 70, 'top': 100 },
            '3.5.1. 폐기물 데이터': { 'avg': 100, 'top': 100 },
            '3.5.2. 폐기물 관리 활동': { 'avg': 78.6, 'top': 100 },
            '3.5.3. 유해 폐기물의 수입 및 수출': { 'avg': 'N/A', 'top': 'N/A' },
            '3.6.1. 대기오염물질 데이터': { 'avg': 90.5, 'top': 100 },
            '3.6.2. 대기오염물질 관리 활동': { 'avg': 73.8, 'top': 100 },
            '3.7.1. 수은 및 수은화합물 관리': { 'avg': 75, 'top': 100 },
            '3.7.2. 잔류성유기오염물질 관리': { 'avg': 'N/A', 'top': 'N/A' },
            '3.7.3. 오존층 파괴물질 관리': { 'avg': 0, 'top': 0 },
            '3.8.2. 자연유산 및 습지': { 'avg': 'N/A', 'top': 'N/A' },
            '3.8.3. 해양 오염 방지': { 'avg': 0, 'top': 0 },
            '4.1.2. 안전 컴플라이언스': { 'avg': 57.1, 'top': 100 },
            '4.2.1. 안전 정책': { 'avg': 95.2, 'top': 100 },
            '4.3.1. 사업장 안전 및 보건 관리': { 'avg': 80.9, 'top': 100 },
            '4.3.2. 재해 방지 및 대응': { 'avg': 82.7, 'top': 100 },
            '4.3.3. 재해 데이터': { 'avg': 91.4, 'top': 100 },
            '4.4.1. 화학물질 안전': { 'avg': 70.4, 'top': 100 }
        }
    },
    '517': {
        'total': {
            'avg': 62.5,
            'top': 76.3
        },
        'category1': {
            '1. 인권 및 노동': { 'avg': 63.8, 'top': 81.6 },
            '2. 윤리': { 'avg': 64.5, 'top': 71.4 },
            '3. 환경': { 'avg': 54.2, 'top': 92 },
            '4. 안전': { 'avg': 64.4, 'top': 99 }
        },
        'category3': {
            '1.1.2. 인권 및 노동 컴플라이언스 리스크': { 'avg': 90, 'top': 100 },
            '1.2.1. 인권 및 노동 정책 내재화': { 'avg': 64.3, 'top': 100 },
            '1.2.2. 근로 관리': { 'avg': 59.5, 'top': 93.8 },
            '1.2.3. 차별금지': { 'avg': 70.5, 'top': 100 },
            '1.3.1. 비인도적 행위 금지': { 'avg': 52.4, 'top': 100 },
            '1.3.2. 아동노동': { 'avg': 60.7, 'top': 81.3 },
            '1.3.3. 강제노동': { 'avg': 71.4, 'top': 100 },
            '1.3.4. 지역사회 및 토착민': { 'avg': 28.6, 'top': 100 },
            '1.4.1. 근로환경 개선 활동': { 'avg': 64.3, 'top': 100 },
            '1.4.2. 결사의 자유': { 'avg': 10.7, 'top': 75 },
            '1.4.3. 고충 처리': { 'avg': 35.7, 'top': 100 },
            '1.6.2. 식당 내 인권 관리': { 'avg': 91.7, 'top': 100 },
            '2.1.1. 윤리 컴플라이언스 리스크': { 'avg': 74.6, 'top': 100 },
            '2.2.1. 윤리 경영': { 'avg': 68, 'top': 100 },
            '2.2.2. 윤리 모니터링': { 'avg': 40.5, 'top': 100 },
            '2.3.1. 개인정보 보호': { 'avg': 67.9, 'top': 100 },
            '2.3.2. 정보 보안': { 'avg': 33.3, 'top': 37.5 },
            '3.1.2. 환경 컴플라이언스 리스크': { 'avg': 94.6, 'top': 100 },
            '3.2.1. 환경 정책': { 'avg': 31.4, 'top': 87.5 },
            '3.2.2. 환경경영 활동': { 'avg': 28.6, 'top': 80 },
            '3.3.1. 온실가스 배출량 관리': { 'avg': 40.5, 'top': 100 },
            '3.3.3. 온실가스 감축 활동': { 'avg': 17.1, 'top': 60 },
            '3.3.4. 에너지 소비 및 전환': { 'avg': 42.9, 'top': 100 },
            '4.1.2. 안전 컴플라이언스': { 'avg': 100, 'top': 100 },
            '4.2.1. 안전 정책': { 'avg': 51.9, 'top': 100 },
            '4.3.1. 사업장 안전 및 보건 관리': { 'avg': 66.9, 'top': 96.7 },
            '4.3.3. 재해 데이터': { 'avg': 71.4, 'top': 100 }
        }
    },
    '518': {
        'total': {
            'avg': 63.9,
            'top': 91.0
        },
        'category1': {
            '1. 인권 및 노동': { 'avg': 66.7, 'top': 93.7 },
            '2. 윤리': { 'avg': 64.9, 'top': 97.8 },
            '3. 환경': { 'avg': 57.1, 'top': 80.5 },
            '4. 안전': { 'avg': 58.0, 'top': 86.3 }
        },
        'category3': {
            '1.1.2. 인권 및 노동 컴플라이언스 리스크': { 'avg': 93.3, 'top': 100 },
            '1.2.1. 인권 및 노동 정책 내재화': { 'avg': 56.7, 'top': 100 },
            '1.2.2. 근로 관리': { 'avg': 73.3, 'top': 100 },
            '1.2.3. 차별금지': { 'avg': 50.6, 'top': 100 },
            '1.3.1. 비인도적 행위 금지': { 'avg': 58.5, 'top': 100 },
            '1.3.2. 아동노동': { 'avg': 40, 'top': 100 },
            '1.3.3. 강제노동': { 'avg': 75.8, 'top': 100 },
            '1.3.4. 지역사회 및 토착민': { 'avg': 25, 'top': 100 },
            '1.4.1. 근로환경 개선 활동': { 'avg': 50, 'top': 100 },
            '1.4.2. 결사의 자유': { 'avg': 56.7, 'top': 100 },
            '1.4.3. 고충 처리': { 'avg': 38.9, 'top': 75 },
            '1.6.2. 식당 내 인권 관리': { 'avg': 66.7, 'top': 66.7 },
            '2.1.1. 윤리 컴플라이언스 리스크': { 'avg': 86.7, 'top': 100 },
            '2.2.1. 윤리 경영': { 'avg': 73.3, 'top': 100 },
            '2.2.2. 윤리 모니터링': { 'avg': 21.3, 'top': 100 },
            '2.3.1. 개인정보 보호': { 'avg': 65, 'top': 100 },
            '2.3.2. 정보 보안': { 'avg': 42.2, 'top': 100 },
            '3.1.2. 환경 컴플라이언스 리스크': { 'avg': 86.7, 'top': 100 },
            '3.2.2. 환경경영 활동': { 'avg': 22.7, 'top': 66.7 },
            '3.3.3. 온실가스 감축 활동': { 'avg': 13.3, 'top': 60 },
            '3.3.4. 에너지 소비 및 전환': { 'avg': 12.2, 'top': 50 },
            '4.1.2. 안전 컴플라이언스': { 'avg': 93.3, 'top': 100 },
            '4.2.1. 안전 정책': { 'avg': 96.7, 'top': 100 },
            '4.3.1. 사업장 안전 및 보건 관리': { 'avg': 34.3, 'top': 96.7 },
            '4.3.3. 재해 데이터': { 'avg': 52, 'top': 60 }
        }
    },
    '519': {
        'total': {
            'avg': 62.5,
            'top': 76.3
        },
        'category1': {
            '1. 인권 및 노동': { 'avg': 63.8, 'top': 81.6 },
            '2. 윤리': { 'avg': 64.5, 'top': 71.4 },
            '3. 환경': { 'avg': 54.2, 'top': 92 },
            '4. 안전': { 'avg': 64.4, 'top': 99 }
        },
        'category3': {
            '1.1.2. 인권 및 노동 컴플라이언스 리스크': { 'avg': 90, 'top': 100 },
            '1.2.1. 인권 및 노동 정책 내재화': { 'avg': 64.3, 'top': 100 },
            '1.2.2. 근로 관리': { 'avg': 59.5, 'top': 93.8 },
            '1.2.3. 차별금지': { 'avg': 70.5, 'top': 100 },
            '1.3.1. 비인도적 행위 금지': { 'avg': 52.4, 'top': 100 },
            '1.3.2. 아동노동': { 'avg': 60.7, 'top': 81.3 },
            '1.3.3. 강제노동': { 'avg': 71.4, 'top': 100 },
            '1.3.4. 지역사회 및 토착민': { 'avg': 28.6, 'top': 100 },
            '1.4.1. 근로환경 개선 활동': { 'avg': 64.3, 'top': 100 },
            '1.4.2. 결사의 자유': { 'avg': 10.7, 'top': 75 },
            '1.4.3. 고충 처리': { 'avg': 35.7, 'top': 100 },
            '1.6.2. 식당 내 인권 관리': { 'avg': 91.7, 'top': 100 },
            '2.1.1. 윤리 컴플라이언스 리스크': { 'avg': 74.6, 'top': 100 },
            '2.2.1. 윤리 경영': { 'avg': 68, 'top': 100 },
            '2.2.2. 윤리 모니터링': { 'avg': 40.5, 'top': 100 },
            '2.3.1. 개인정보 보호': { 'avg': 67.9, 'top': 100 },
            '2.3.2. 정보 보안': { 'avg': 33.3, 'top': 37.5 },
            '3.1.2. 환경 컴플라이언스 리스크': { 'avg': 94.6, 'top': 100 },
            '3.2.1. 환경 정책': { 'avg': 31.4, 'top': 87.5 },
            '3.2.2. 환경경영 활동': { 'avg': 28.6, 'top': 80 },
            '3.3.1. 온실가스 배출량 관리': { 'avg': 40.5, 'top': 100 },
            '3.3.3. 온실가스 감축 활동': { 'avg': 17.1, 'top': 60 },
            '3.3.4. 에너지 소비 및 전환': { 'avg': 42.9, 'top': 100 },
            '4.1.2. 안전 컴플라이언스': { 'avg': 100, 'top': 100 },
            '4.2.1. 안전 정책': { 'avg': 51.9, 'top': 100 },
            '4.3.1. 사업장 안전 및 보건 관리': { 'avg': 66.9, 'top': 96.7 },
            '4.3.3. 재해 데이터': { 'avg': 71.4, 'top': 100 }
        }
    },
    '520': {
        'total': {
            'avg': 74.4,
            'top': 89.2
        },
        'category1': {
            '1. 인권 및 노동': { 'avg': 71.2, 'top': 91.4 },
            '2. 윤리': { 'avg': 78.4, 'top': 96.2 },
            '3. 환경': { 'avg': 81.7, 'top': 100 },
            '4. 안전': { 'avg': 84.1, 'top': 100 }
        },
        'category3': {
            '1.1.2. 인권 및 노동 컴플라이언스 리스크': { 'avg': 91.7, 'top': 100 },
            '1.2.1. 인권 및 노동 정책 내재화': { 'avg': 51.1, 'top': 100 },
            '1.2.2. 근로 관리': { 'avg': 69.4, 'top': 100 },
            '1.2.3. 차별금지': { 'avg': 72.8, 'top': 100 },
            '1.3.1. 비인도적 행위 금지': { 'avg': 49.3, 'top': 100 },
            '1.3.2. 아동노동': { 'avg': 68.8, 'top': 100 },
            '1.3.3. 강제노동': { 'avg': 78.7, 'top': 100 },
            '1.3.4. 지역사회 및 토착민': { 'avg': 9.8, 'top': 100 },
            '1.4.1. 근로환경 개선 활동': { 'avg': 75.5, 'top': 100 },
            '1.4.2. 결사의 자유': { 'avg': 34.4, 'top': 100 },
            '1.4.3. 고충 처리': { 'avg': 74.2, 'top': 100 },
            '1.6.2. 식당 내 인권 관리': { 'avg': 87.5, 'top': 100 },
            '2.1.1. 윤리 컴플라이언스 리스크': { 'avg': 91.3, 'top': 100 },
            '2.2.1. 윤리 경영': { 'avg': 70.1, 'top': 100 },
            '2.2.2. 윤리 모니터링': { 'avg': 64.5, 'top': 100 },
            '2.3.1. 개인정보 보호': { 'avg': 82.6, 'top': 100 },
            '2.3.2. 정보 보안': { 'avg': 56.5, 'top': 100 },
            '3.1.2. 환경 컴플라이언스 리스크': { 'avg': 100, 'top': 100 },
            '3.2.2. 환경경영 활동': { 'avg': 33, 'top': 100 },
            '4.1.2. 안전 컴플라이언스': { 'avg': 100, 'top': 100 },
            '4.2.1. 안전 정책': { 'avg': 82.6, 'top': 100 },
            '4.3.1. 사업장 안전 및 보건 관리': { 'avg': 60, 'top': 100 }
        }
    },
    '521': {
        'total': {
            'avg': 64.7,
            'top': 80.8
        },
        'category1': {
            '1. 인권 및 노동': { 'avg': 67.2, 'top': 85.6 },
            '2. 윤리': { 'avg': 68.1, 'top': 95.2 },
            '3. 환경': { 'avg': 51.5, 'top': 73.6 },
            '4. 안전': { 'avg': 73.3, 'top': 92.3 }
        },
        'category3': {
            '1.1.2. 인권 및 노동 컴플라이언스 리스크': { 'avg': 91.2, 'top': 100 },
            '1.2.1. 인권 및 노동 정책 내재화': { 'avg': 63.2, 'top': 100 },
            '1.2.2. 근로 관리': { 'avg': 75.5, 'top': 93.8 },
            '1.2.3. 차별금지': { 'avg': 30.9, 'top': 100 },
            '1.3.1. 비인도적 행위 금지': { 'avg': 62.1, 'top': 100 },
            '1.3.2. 아동노동': { 'avg': 25.7, 'top': 50 },
            '1.3.3. 강제노동': { 'avg': 73.8, 'top': 100 },
            '1.3.4. 지역사회 및 토착민': { 'avg': 29.4, 'top': 100 },
            '1.4.1. 근로환경 개선 활동': { 'avg': 79.4, 'top': 100 },
            '1.4.2. 결사의 자유': { 'avg': 64.7, 'top': 100 },
            '1.4.3. 고충 처리': { 'avg': 19.6, 'top': 58.3 },
            '1.6.2. 식당 내 인권 관리': { 'avg': 96.7, 'top': 100 },
            '2.1.1. 윤리 컴플라이언스 리스크': { 'avg': 94.1, 'top': 100 },
            '2.2.2. 윤리 모니터링': { 'avg': 28.2, 'top': 100 },
            '2.3.1. 개인정보 보호': { 'avg': 54.4, 'top': 100 },
            '2.3.2. 정보 보안': { 'avg': 53.9, 'top': 100 },
            '3.1.2. 환경 컴플라이언스 리스크': { 'avg': 97.8, 'top': 100 },
            '3.2.1. 환경 정책': { 'avg': 89.7, 'top': 100 },
            '3.2.2. 환경경영 활동': { 'avg': 52.2, 'top': 100 },
            '3.3.1. 온실가스 배출량 관리': { 'avg': 31.4, 'top': 100 },
            '3.3.3. 온실가스 감축 활동': { 'avg': 40, 'top': 100 },
            '3.3.4. 에너지 소비 및 전환': { 'avg': 32.4, 'top': 50 },
            '3.4.1. 수자원 데이터': { 'avg': 52.1, 'top': 100 },
            '3.4.2. 수자원 관리 활동': { 'avg': 14.8, 'top': 75 },
            '3.5.1. 폐기물 데이터': { 'avg': 60.8, 'top': 100 },
            '3.5.2. 폐기물 관리 활동': { 'avg': 21.3, 'top': 50 },
            '3.5.3. 유해 폐기물의 수입 및 수출': { 'avg': 'N/A', 'top': 'N/A' },
            '3.6.1. 대기오염물질 데이터': { 'avg': 38.6, 'top': 100 },
            '3.6.2. 대기오염물질 관리 활동': { 'avg': 15.7, 'top': 66.7 },
            '4.1.2. 안전 컴플라이언스': { 'avg': 94.1, 'top': 100 },
            '4.2.1. 안전 정책': { 'avg': 76.5, 'top': 100 },
            '4.3.1. 사업장 안전 및 보건 관리': { 'avg': 70, 'top': 100 },
            '4.3.2. 재해 방지 및 대응': { 'avg': 82.9, 'top': 100 },
            '4.3.3. 재해 데이터': { 'avg': 74.9, 'top': 100 },
            '4.4.1. 화학물질 안전': { 'avg': 55.9, 'top': 88.9 }
        }
    }
};

export {benchmark_score};
